import React, { useState, useEffect } from "react";
import { Button, Field, Checkbox, Form, Input } from "../Forms/";

export default function Expansion({ stand, register, setModal, setShow, setState, state, surface }) {
    const [selectedExpansions, setSelectedExpansions] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [showItems, setShowItems] = useState(false);

    const parsePrice = (price) => {
        if (typeof price === 'string') {
            return parseFloat(price.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
        }
        return parseFloat(price) || 0;
    };

    // One initial change from global state at mount
    useEffect(() => {
        setSelectedExpansions(state.selectedExpansions || []);
    }, []);

     // Checks if the Surface (input field) is active so that we know if we need to calculate with m2
    const isSurfaceActive = () => state.options[state.stand].add_surface && state.surface !== '';

    // Calculate total price when expansions change
    useEffect(() => {


        const expansionsTotal = selectedExpansions.reduce((acc, curr) => acc + parsePrice(curr.price), 0);
        const basePrice = parsePrice(stand.price);
        if (isSurfaceActive()) {
            const Price = parsePrice(surface) * basePrice;
            const total = Price + expansionsTotal
            setTotalPrice(total);
        } else {
            const total = basePrice + expansionsTotal;
            setTotalPrice(total);
        }
    }, [selectedExpansions, stand.price, surface]);

    // Only save local changes
    const handleCheckboxChange = (expansionItem, checked) => {
        setSelectedExpansions((prevExpansions) => {
            let updatedExpansions;
            if (checked) {
                updatedExpansions = [...prevExpansions, expansionItem];
            } else {
                updatedExpansions = prevExpansions.filter(item => item.title !== expansionItem.title);
            }
            const expansionsTotal = selectedExpansions.reduce((acc, curr) => acc + parsePrice(curr.price), 0);
            const basePrice = parsePrice(stand.price);
            if (isSurfaceActive()) {
                const Price = parsePrice(surface) * basePrice;
                const total = Price + expansionsTotal
                setTotalPrice(total);
            } else {
                const total = basePrice + expansionsTotal;
                setTotalPrice(total);
            }

            return updatedExpansions;
        });
    };

    const handleShowMore = (e) => {
        e.preventDefault();
        setShowItems((prev) => !prev);
    };

    // Change global state when component unmounts
    useEffect(() => {
        return () => {
            setState((prev) => ({
                ...prev,
                selectedExpansions,
                totalPrice
            }));
        };
    }, [selectedExpansions, totalPrice, setState]);

    return (
        <div>
            {stand.expansion &&
                // Check if the stand has expansions and if the expansions have a title and price. If the expansion dont have a title or price dont show it at all.
                stand.add_expansion && stand.expansion.some(expansionItem => expansionItem.title !== '' && expansionItem.price !== '' ) && (
                <div className="stand__item__field stand__item__field-expansion">
                    <div className="stand__item__field-title">
                        <span>Uitbreidingen:</span>
                        {stand.expansion_modal_content !== null ?
                            <a onClick={() => { setShow(true); setModal(stand.title, stand.expansion_modal_content); }}>
                                <i className="fa-solid fa-square-info"></i>Bekijk details
                            </a>
                            : ''}
                    </div>

                    <div className={`stand__item__field-expand ${showItems ? 'showItems' : ''}`}>
                        {stand.expansion &&
                            // If there is atleist one expansion with a title and price show it
                            stand.expansion.slice(0, showItems ? stand.expansion.length : 3).map((expansionItem, index) => (
                                expansionItem.title !== '' && expansionItem.price !== '' && (
                                <div className="form__field box__input" key={index}>
                                    <Input
                                    id={`expansion-${index}`}
                                    type="checkbox"
                                    value={expansionItem.title}
                                    checked={selectedExpansions.some((item) => item.title === expansionItem.title)}
                                    onChange={(e) => handleCheckboxChange(expansionItem, e.target.checked)}
                                    />
                                    <label htmlFor={`expansion-${index}`}>{expansionItem.title}</label>
                                    <span>€ {expansionItem.price},-</span>
                                </div>
                                )
                            ))
                        }
                    </div>


                    <div className="stand__item__field-footer">

                        {stand.expansion && stand.expansion.length > 3 && (
                            <a href="#" className="stand__item__footer-toggle" onClick={handleShowMore}>
                                {showItems ? 'Minder uitbreidingen' : 'Meer uitbreidingen'}
                                <i className={`fas fa-angle-${showItems ? 'up' : 'down'}`}></i>
                            </a>
                        )}

                        <div className="stand__item__total-price">
                            <span className="label">Totaal: </span>
                            <span className="price">€ {totalPrice},-</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
